import axios from "axios";
import { ServerSideTypes } from "../common/OperationCommonTypes";

export interface IFilter {
  type?: string;
}

const ExportService = {
  vehicle: {
    get: {
      asyncExport: (filters: IFilter, serverParams: ServerSideTypes.IParams) => {
        return axios
          .get("/masterdatavehicle/asyncexport", {
            params: {
              ...filters,
              ...serverParams,
            },
          })
          .then((response) => response.data);
      },
  
      asyncExportById: (id: number) => {
        return axios.get(`/masterdatavehicle/asyncexport/${id}/file`, {
          responseType: "arraybuffer",
          headers: { "Access-Control-Allow-Origin": true },
        });
      },
    }
  },
  damage: {
    get: {
      asyncExport: (filters: IFilter, serverParams: ServerSideTypes.IParams) => {
        return axios
          .get("/masterdatadamage/asyncexport", {
            params: {
              ...filters,
              ...serverParams,
            },
          })
          .then((response) => response.data);
      },
  
      asyncExportById: (id: number) => {
        return axios.get(`/masterdatadamage/asyncexport/${id}/file`, {
          responseType: "arraybuffer",
          headers: { "Access-Control-Allow-Origin": true },
        });
      },
    }
  },
  transportation: {
    get: {
      asyncExport: (filters: IFilter, serverParams: ServerSideTypes.IParams) => {
        return axios
          .get("/masterdatatransportation/asyncexport", {
            params: {
              ...filters,
              ...serverParams,
            },
          })
          .then((response) => response.data);
      },
  
      asyncExportById: (id: number) => {
        return axios.get(`/masterdatatransportation/asyncexport/${id}/file`, {
          responseType: "arraybuffer",
          headers: { "Access-Control-Allow-Origin": true },
        });
      },
    }
  },
};

export default ExportService;
